import { Box, Card, CardContent, Typography, Grid } from '@mui/material';
import type { ReactNode } from 'react';

export interface Feature {
  icon: ReactNode;
  title: string;
  description: string;
}

interface FeatureGridProps {
  features: Feature[];
  columns?: number;
}

export const FeatureGrid = ({ features, columns = 3 }: FeatureGridProps) => {
  return (
    <Grid container spacing={3}>
      {features.map((feature, index) => (
        <Grid
          key={index}
          size={{ xs: 12, sm: 6, md: 12 / columns }}
        >
          <Card
            sx={{
              height: '100%',
              textAlign: 'center',
              transition: 'transform 0.2s, box-shadow 0.2s',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 4,
              },
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Box
                sx={{
                  mb: 2,
                  color: 'primary.main',
                  '& svg': { fontSize: 48 },
                }}
              >
                {feature.icon}
              </Box>
              <Typography variant="h6" gutterBottom fontWeight={600}>
                {feature.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {feature.description}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};
